module.exports = __webpack_public_path__ + "static/img/downloadqr.0203d945.png";